<template>
  <b-overlay
    variant="white"
    spinner-variant="primary"
    blur="0"
    opacity=".75"
    rounded="sm"
    :show="isLoading"
  >
    <b-card no-body>
      <b-card-body>
        <b-row class="mb-2">
          <b-col cols="12" class="text-right">
            <b-button v-if="creatable" variant="success" @click="openModal" v-b-modal.modal>
              <feather-icon icon="PlusIcon" class="mr-1" />
              Thêm mới chứng chỉ
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <vue-good-table
              :columns="columns"
              :rows="dataSources"
              :pagination-options="paginationOptions"
              :line-numbers="true"
            >
              <div
                slot="emptystate"
                style="text-align: center; font-weight: bold"
              >
                Không có bản ghi nào !
              </div>
              <template
                slot="table-row"
                slot-scope="props"
              >
                <span v-if="props.column.field === 'studentCertificateType'">
                  {{ getCertificateName(props.row.studentCertificateType) }}
                </span>
                <span v-else-if="props.column.field === 'studentCertificateStatus'">
                  {{ getStatusName(props.row.studentCertificateStatus) }}
                </span>
                <span v-else-if="props.column.field === 'action'">
                  <b-button
                    v-if="updatable"
                    v-b-modal.modal
                    variant="primary"
                    class="btn-icon"
                    size="sm"
                    @click="onEdit(props.row)"
                  >
                    <feather-icon icon="Edit2Icon" />
                  </b-button>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-modal
      id="files-save"
      ref="files-save"
      ok-only
      ok-title="Chấp nhận"
      centered
      size="lg"
      :title="isCreated ? 'Thêm chứng chỉ' : 'Cập nhật chứng chỉ'"
      :hide-footer="true"
    >
      <StudentFileSave :data="currentData" @succeed="onSucceed"
      />
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BCard, BCardBody, BCol, BOverlay, BRow, BButton
} from 'bootstrap-vue'
import { getUser } from '@/auth/utils'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { hasPermissionForResource } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import StudentFileSave from '@/views/study/student-certificate/StudentCertificateSave.vue'
import { CERTIFICATE_STATUS, CERTIFICATE_TYPES } from '@/const/status'
import api from './api'

export default {
  name: 'StudentCertificate',
  components: {
    StudentFileSave,
    BCol,
    BRow,
    BCard,
    BCardBody,
    BOverlay,
    VueGoodTable,
    BButton,
  },
  data() {
    return {
      isLoading: false,
      user: getUser(),
      columns: [
        {
          label: 'Tên sinh viên',
          field: 'studentName',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Loại chứng chỉ',
          field: 'studentCertificateType',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          field: 'studentCertificateStatus',
          label: 'Trạng thái',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          field: 'action',
          label: '',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
      paginationOptions: {
        enabled: false,
      },
      filter: {
        studentId: null,
        status: null,
        currentPage: 1,
        itemsPerPage: 1000,
      },
      dataSources: [],
      currentData: undefined
    }
  },
  computed: {
    creatable() {
      return hasPermissionForResource(PermissionCode.CREATE, ResourceCode.PORTAL_STUDENT_CERTIFICATE)
    },
    updatable() {
      return hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.PORTAL_STUDENT_CERTIFICATE)
    },
    isCreated() {
      return this.currentData === undefined || this.currentData === null
    },
  },
  async created() {
    await this.getDataSourceFromStore()
  },
  methods: {
    async getDataSourceFromStore() {
      this.isLoading = true
      try {
        this.filter.studentId = this.user.studentId
        const res = await api.getStudentCertificate(this.filter)
        this.dataSources = res.records
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    onEdit(data) {
      this.currentData = data
      this.$refs['files-save'].show()
    },
    openModal() {
      this.currentData = undefined
      this.$refs['files-save'].show()
    },
    async onSucceed() {
      await this.getDataSourceFromStore()
    },
    getCertificateName(id) {
      return CERTIFICATE_TYPES.find(status => status.value === id).label
    },
    getStatusName(id) {
      return CERTIFICATE_STATUS.find(status => status.value === id).label
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table';
</style>
